import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { cancelResendAPI, getAllIngestionsAPI, getIngestionMonitorAPI, getResendStatusDataAPI, resendCustomersAPI } from "./endpoints";

function* getIngestionMonitorSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getIngestionMonitorAPI, action.payload);
    yield put(actions.setIngestionMonitor(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getAllIngestionsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getAllIngestionsAPI, action.payload);
    yield put(actions.setAllIngestions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getResendStatusDataSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getResendStatusDataAPI, action.payload);
    yield put(actions.setResendCustomerData(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getResendCustomersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(resendCustomersAPI, action.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(actions.setResendCustomers(true));
      yield put(
        commonActions.setAlert({
          message: "Resend to SAP request has been submitted",
          alertType: "success",
          showToast: true,
        })
      );
      yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    yield put(commonActions.setLoading(false));
    const hasValidationError = error?.response?.data?.results?.length;
    if (hasValidationError) {
      yield put(
        commonActions.setAlert({
          message: (hasValidationError === 1) ? "alreadySubmitted_one" : "alreadySubmitted_other",
          alertType: "error",
          showToast: true,
          dynamicToastValue: { value: error?.response?.data?.results?.join(", ") || "" }
        })
      );
    } else {
      yield put(
        commonActions.setAlert({
          message: error.message || "Resend to SAP request has been failed",
          alertType: "error",
          showToast: true
        })
      );
    }
    console.log(error);
  }
}

function* cancelResendSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(cancelResendAPI, action.payload.payload);
    if (_api?.data?.success) {
      yield put(commonActions.setLoading(false));
      yield put(actions.setCancelResend(true));
      yield put(actions.getResendCustomerData(action.payload.filters));
      yield put(
        commonActions.setAlert({
          message: "Resend to SAP Cancelled",
          alertType: "success",
          showToast: true,
        })
      );
      yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    yield put(commonActions.setLoading(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Cancel Resend Failed",
        alertType: "error",
        showToast: true,
      })
    );
  }
}

export function* withIngestionMonitorSaga() {
  yield all([
    takeEvery(actionTypes.GET_INGESTION_MONITOR, getIngestionMonitorSaga),
    takeEvery(actionTypes.RESEND_CUSTOMERS_TO_SAP, getResendCustomersSaga),
    takeEvery(actionTypes.GET_ALL_INGESTIONS, getAllIngestionsSaga),
    takeEvery(actionTypes.GET_RESEND_CUSTOMER_DATA, getResendStatusDataSaga),
    takeEvery(actionTypes.CANCEL_RESEND, cancelResendSaga),
  ]);
}
